var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb_map_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Final_icons_-_Common",
    "data-name": "Final icons - Common"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.62,22H22.26c-.6.74-1.21,1.41-1.79,2h3.91l2,4H5.62l2-4h3.76c-.58-.59-1.19-1.26-1.79-2H6.38l-4,8H29.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.92,2A9,9,0,0,0,7,11c0,7.8,8.92,14.4,8.92,14.4S25,18.8,25,11A9.12,9.12,0,0,0,15.92,2Zm0,13.15a4,4,0,1,1,4-4A4,4,0,0,1,15.92,15.15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentMap);
export default __webpack_public_path__ + "static/media/DocumentMap.9e418f9827dd73e417ce0b646e048a61.svg";
export { ForwardRef as ReactComponent };